import { Instagram, Twitter, Youtube } from "lucide-react";
import { useTranslation } from "react-i18next";
import useSocialLinks from "@/lib/useSocialLinks";

const ITEMS = [
  { key: "instagram", Icon: Instagram, labelKey: "landingUi2.instagram" },
  { key: "twitter", Icon: Twitter, labelKey: "landingUi2.twitter" },
  { key: "youtube", Icon: Youtube, labelKey: "landingUi2.youtube" },
];

export const SocialLinks = ({ testIdPrefix, className = "" }) => {
  const { t } = useTranslation();
  const links = useSocialLinks();
  const visible = ITEMS.filter(({ key }) => links?.[key]);
  if (!visible.length) return null;
  return (
    <div data-testid={`${testIdPrefix}s`} className={`flex flex-wrap items-center gap-3 ${className}`}>
      {visible.map(({ key, Icon, labelKey }) => (
        <a
          key={key}
          href={links[key]}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testIdPrefix}-${key}`}
          className="inline-flex items-center gap-2 rounded-full border border-slate-200 hover:border-blue-800 bg-white px-5 h-11 text-sm font-semibold text-slate-900 hover:text-blue-800 transition-colors"
        >
          <Icon size={16} /> {t(labelKey)}
        </a>
      ))}
    </div>
  );
};
